import { Box, Typography } from '@mui/material';
import { useListContext, useTranslate } from 'react-admin';
import { CustomButton } from '@/components/global/buttons/CustomButton';
import NotificationBox from '@/components/global/fields/NotificationBox.jsx';
import { getActiveFilters, getGroupedActiveFilterCount } from '@/helpers/filters/activeFilters.js';

export const CustomListNoResults = () => {
    const translate = useTranslate();
    const { filterValues, setFilters, displayedFilters } = useListContext();
    const hasFilters = getGroupedActiveFilterCount(getActiveFilters(filterValues ?? {})) > 0;

    return (
        <Box
            className='list-no-results'
            sx={{
                margin: '20px 0px',
                width: '100%',
                '& .notification-box > .MuiTypography-root': {
                    flex: 1,
                    minWidth: 0,
                },
            }}
        >
            <NotificationBox variant='info' className='large'>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', width: '100%' }}>
                    <Typography variant='body1'>{translate(hasFilters ? 'ra.navigation.no_filtered_results' : 'ra.navigation.no_results')}</Typography>
                    {hasFilters && setFilters ? (
                        <CustomButton
                            className='white'
                            label='ra.navigation.clear_filters'
                            onClick={() => setFilters({}, displayedFilters, false)}
                            size='small'
                            sx={{ marginLeft: 'auto', flexShrink: 0 }}
                            variant='contained'
                        />
                    ) : null}
                </Box>
            </NotificationBox>
        </Box>
    );
};
